/**
 * Created by evgeny on 26.04.2024
 */

const KingsCupButterfly = function () {
    cleverapps.EventEmitter.call(this);
    cleverapps.Board.unguessedLetters.push(cleverapps.Board.KINGSCUP_BUTTERFLY);

    Game.currentGame.board.on("afterShowUp", this.showUp.bind(this));
    Game.currentGame.board.on("collect", this.collect.bind(this));
    Game.currentGame.board.on("beforeDiscover", this.setFilterForPositions.bind(this));
    Game.currentGame.board.on("hide", this.trigger.bind(this, "hideButterfly"));
};

KingsCupButterfly.prototype = Object.create(cleverapps.EventEmitter.prototype);
KingsCupButterfly.prototype.constructor = KingsCupButterfly;

KingsCupButterfly.prototype.setFilterForPositions = function (word) {
    this.wordLettersPositions = Game.currentGame.board.listWordIndexes(word);
};

KingsCupButterfly.prototype._choosePosition = function () {
    let positions = Game.currentGame.board.listEmptyUnguessedPositions();

    if (this.wordLettersPositions) {
        positions = positions.filter((position) => !this.wordLettersPositions.find((letterPosition) => position.row === letterPosition[0] && position.column === letterPosition[1]));
    }

    if (positions.length) {
        return PseudoRandom.GET().choose(positions);
    }
};

KingsCupButterfly.prototype.createView = function () {
    new KingsCupButterflyView(this);
};

KingsCupButterfly.prototype.showUp = function (silent) {
    const position = this._choosePosition();

    if (position) {
        Game.currentGame.board.addState(position.row, position.column, cleverapps.Board.KINGSCUP_BUTTERFLY);
        this.createView();
        this.trigger("addButterfly", position.row, position.column, silent);
    }
};

KingsCupButterfly.prototype.collect = function (row, col) {
    if (Game.currentGame.board.guessedField[row][col] !== cleverapps.Board.KINGSCUP_BUTTERFLY) {
        return;
    }

    const position = this._choosePosition();

    const game = Game.currentGame;

    cleverapps.eventBus.trigger("collectKingsCupMark", 1);
    game.saveStable();

    if (!position) {
        game.counter.inc();
    }

    this.trigger("collectButterfly", row, col, () => {
        cleverapps.eventBus.trigger("kingsCupMarkArrived", 1);
        if (!position) {
            game.counter.dec();
        }
    });

    if (!position) {
        this.trigger("hideButterfly");
        return;
    }

    Game.currentGame.board.addState(position.row, position.column, cleverapps.Board.KINGSCUP_BUTTERFLY);
    this.trigger("moveButterfly", position.row, position.column);
};

cleverapps.Board.KINGSCUP_BUTTERFLY = "$";
